import { render, staticRenderFns } from "./CollectionCrud.vue?vue&type=template&id=562c05be"
import script from "./CollectionCrud.vue?vue&type=script&lang=js"
export * from "./CollectionCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports